import * as React from 'react'
import { FC } from 'react'
import Box, { BoxProps } from '@mui/material/Box'

const SharedBackground: FC<BoxProps<'svg'>> = (props) => (
  <Box
    component={'svg'}
    width={48}
    height={48}
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M13.1299 28.0101L4.90988 24.6101C4.36988 24.3901 4.36988 23.6301 4.90988 23.4101L13.1299 20.0101C13.4599 19.8701 13.6199 19.4901 13.4799 19.1601L10.0799 10.9401C9.85988 10.4001 10.3899 9.87014 10.9299 10.0901L19.1499 13.4901C19.4799 13.6301 19.8599 13.4701 19.9999 13.1401L23.3999 4.92014C23.6199 4.38014 24.3799 4.38014 24.5999 4.92014L27.9999 13.1401C28.1399 13.4701 28.5199 13.6301 28.8499 13.4901L37.0699 10.0901C37.6099 9.87014 38.1399 10.4001 37.9199 10.9401L34.5199 19.1601C34.3799 19.4901 34.5399 19.8701 34.8699 20.0101L43.0899 23.4101C43.6299 23.6301 43.6299 24.3901 43.0899 24.6101L34.8699 28.0101C34.5399 28.1501 34.3799 28.5301 34.5199 28.8601L37.9199 37.0801C38.1399 37.6201 37.6099 38.1501 37.0699 37.9301L28.8499 34.5301C28.5199 34.3901 28.1399 34.5501 27.9999 34.8801L24.5999 43.1001C24.3799 43.6401 23.6199 43.6401 23.3999 43.1001L19.9999 34.8801C19.8599 34.5501 19.4799 34.3901 19.1499 34.5301L10.9299 37.9301C10.3899 38.1501 9.85988 37.6201 10.0799 37.0801L13.4799 28.8601C13.6199 28.5301 13.4599 28.1501 13.1299 28.0101Z"
      fill="#FF612B"
    />
    <path
      d="M21.1099 15.43C20.6199 14.94 19.8299 14.94 19.3399 15.43C18.8499 15.92 18.8499 16.71 19.3399 17.2L20.8099 18.67H10.3999C9.7099 18.67 9.1499 19.23 9.1499 19.92C9.1499 20.61 9.7099 21.17 10.3999 21.17H20.8099L19.3399 22.64C18.8499 23.13 18.8499 23.92 19.3399 24.41C19.5799 24.65 19.8999 24.78 20.2199 24.78C20.5399 24.78 20.8599 24.66 21.0999 24.41L25.5899 19.92L21.0999 15.43H21.1099Z"
      fill="#3D3C38"
    />
    <path
      d="M37.5999 26.8302H27.1899L28.6599 25.3602C29.1499 24.8702 29.1499 24.0802 28.6599 23.5902C28.1699 23.1002 27.3799 23.1002 26.8899 23.5902L23.2799 27.1902L22.3999 28.0802L26.8899 32.5702C27.1299 32.8102 27.4499 32.9402 27.7699 32.9402C28.0899 32.9402 28.4099 32.8202 28.6499 32.5702C29.1399 32.0802 29.1399 31.2902 28.6499 30.8002L27.1799 29.3302H37.5899C38.2799 29.3302 38.8399 28.7702 38.8399 28.0802C38.8399 27.3902 38.2799 26.8302 37.5899 26.8302H37.5999Z"
      fill="#002677"
    />
  </Box>
)

export default SharedBackground
